import { render, staticRenderFns } from "./DefaultFormBuilder.vue?vue&type=template&id=4ddd93ac&"
import script from "./DefaultFormBuilder.vue?vue&type=script&lang=ts&"
export * from "./DefaultFormBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports